define('viewmodels/pages/player/dashboard',[
   'knockout'
], function (ko) {

    function DashboardViewModel(
		playerTabs,
        dashbaordFieldFetcher,
        tournamentCampaigns,
        // Adventure related injected parameters
        session,
        adventurers,
        adventureFieldFetcher
    ) {
        var self = this;

        self.subNav = playerTabs;

        self.meta = {
            title: dashbaordFieldFetcher('meta_title'),
            description: dashbaordFieldFetcher('meta_description')
        };

        self.tournamentCampaigns = tournamentCampaigns;
        self.isCurrentPlayerOptedIntoNext = tournamentCampaigns.activeCampaign.property('nextTournament').property('currentPlayerOptedIn').orElse(false);

        /**
         * We moved all the adventure view model in the dashboard view model
         * ELABORATE MORE
         */

        self.locationPreposition = adventureFieldFetcher('location_preposition');
        self.travellingState = adventureFieldFetcher('travelling_state');

        self.playerIdOrCasumoName = ko.observable().withFallback(session.id);

        self.adventurer = ko.pureComputed(function () {
            return adventurers.getByPlayerIdOrCasumoName(self.playerIdOrCasumoName());
        });

        self.adventure = ko.pureComputed(function () {
            return self.adventurer().getAdventure();
        });

        self.adventureLoaded = ko.pureComputed(function () {
            return self.adventure.loaded();
        });

        self.planetName = ko.pureComputed(function () {
            return self.location().currentPlanet().name();
        });

        self.nextPlanetName = ko.pureComputed(function () {
            return self.nextPlanet().name();
        });

        self.locationText = ko.pureComputed(function () {
            return self.travelling() ?
                self.travellingState() :
                self.locationPreposition() + ' ' + self.planetName();
        });

        self.travelling = ko.pureComputed(function () {
            return self.location().travelling();
        });

        self.location = ko.pureComputed(function () {
            return self.adventure().location;
        });

        self.nextPlanet = ko.pureComputed(function () {
            return self.location().nextPlanet();
        });

        self.backgroundImage = ko.pureComputed(function () {
            return self.travelling() ?
                '../../images/backgrounds/space.png' :
                self.location().currentPlace().atmosphereImage();
        });

        self.planetImage = ko.pureComputed(function () {
            return self.location().currentPlace().image();
        });
    }

    return DashboardViewModel;
});


